<template>
  <div class="font-weight-light">
    <!-- ABOUT -->
    <section>
      <div class="container pb-5">
        <h1 class="font-size-xxxLarge text-center mb-5"><span class="highlighted highlight-left">A Scriv</span></h1>
        <!-- READER -->
        <div class="text-center d-flex flex-column flex-lg-row align-items-lg-center justify-content-center">
          <div class="text-lg-left col-lg-4">
            <h2 class="font-size-xLarge">Onde escritores <br/>e leitores se <br/><span class="highlighted highlight-left">encontram</span></h2>
          </div>
          <div class="mt-4 col-lg-8 text-lg-left">
            <p class="quoted font-size-lg-medium">Mais do que uma rede social para leitores e escritores, somos uma comunidade de compartilhamento de ideias, conectando pequenos autores aos inúmeros leitores sedentos por novos conteúdos.</p>
          </div>
        </div><!-- END READER -->

        <!-- WRITERS -->
        <div class="text-center mt-5 d-flex flex-column flex-lg-row align-items-lg-center justify-content-center">
          <div class="order-lg-2 text-lg-left col-lg-4 pl-lg-5">
            <h2 class="font-size-xLarge">Empoderando <br/><span class="highlighted highlight-right">criadores</span> <br/><span class="highlighted highlight-right">de conteúdo</span></h2>
          </div>
          <div class="mt-4 order-lg-1 text-lg-left col-lg-8">
            <p class="quoted font-size-lg-medium">Queremos gerar oportunidades aos criadores de conteúdo literário, criando um local seguro para escreverem seus textos, histórias, crônicas, contos, editoriais, reviews, opiniões, e, é claro, livros.</p>
          </div>
        </div> <!-- END WRITERS -->

        <!-- ACCESS -->
        <div class="text-center mt-5 d-flex flex-column flex-lg-row align-items-lg-center justify-content-center">
          <div class="text-lg-left col-lg-4">
            <h2 class="font-size-xLarge"><span class="highlighted highlight-left">Democratizar</span><br/><span class="highlighted highlight-left">a publicação</span><br/>no Brasil</h2>
          </div>
          <div class="mt-4 col-lg-8 text-lg-left">
            <p class="quoted font-size-lg-medium">Com muito orgulho, somos uma plataforma feita por brasileiros para brasileiros, com o objetivo de democratizar a oportunidade da publicação pra todos os autores nacionais independentes.</p>
          </div>
        </div><!-- END ACCESS -->

      </div>
    </section> <!-- END ABOUT -->

    <!-- CYCLE -->
    <section id="cycle">
      <div class="container pb-5">
        <hr class="h-1 no-border background-color2 mb-5" />

        <h2 class="font-size-xLarge text-center text-md-left"><span class="highlighted highlight-left">O Ciclo Scriv</span> de Publicação</h2>

        <div class="mt-5 d-flex flex-column flex-md-row flex-wrap justify-content-center">
          <div class="text-center item mb-4 mb-md-0">
            <img src="/images/pages/about/icon-cycle-1.png" alt="" class="mb-3" />
            <p>Sem riscos ou <br/>custos para lançar <br/>seu novo livro</p>
            <p class="font-size-small text-color2">Escreva seu livro e <br/>publique seus textos <br/>sem custo nenhum</p>
          </div>
          <div class="text-center item mb-4 mb-md-0">
            <img src="/images/pages/about/icon-cycle-2.png" alt="" class="mb-3" />
            <p>Preços reduzidos <br/>para democratizar <br/>os conteúdos</p>
            <p class="font-size-small text-color2">Cada autor e autora <br/>define os preços de <br/>suas próprias obras</p>
          </div>
          <div class="text-center item mb-4 mb-md-0">
            <img src="/images/pages/about/icon-cycle-3.png" alt="" class="mb-3" />
            <p>Mais oportunidades <br/>para novos autores e <br/>leitores brasileiros</p>
            <p class="font-size-small text-color2">Venda livros unitários, <br/>capítulos individuais ou <br/>até planos de assinaturas</p>
          </div>
          <div class="text-center item mb-4 mb-md-0">
            <img src="/images/pages/about/icon-cycle-4.png" alt="" class="mb-3" />
            <p>Crescimento de <br/>novos conteúdos <br/>e público potencial</p>
            <p class="font-size-small text-color2">Use tags relacionadas <br/>e participe de eventos <br/>para captar novos leitores</p>
          </div>
          <div class="text-center item">
            <img src="/images/pages/about/icon-cycle-5.png" alt="" class="mb-3" />
            <p>Aumento nas vendas <br/>e maior estímulo <br/>no setor editorial</p>
            <p class="font-size-small text-color2">Receba o valor direto <br/>pela sua Scriv Wallet, <br/>com total segurança</p>
          </div>
        </div>

        <div class="mt-5 text-center">
          <img src="/images/pages/about/cycle-img.png" alt="" />
        </div>
      </div>
    </section> <!-- END CYCLE -->

    <!-- MONEY -->
    <section>
      <div class="container pb-5 text-center text-md-left">
        <h2 class="font-size-xLarge mb-4"><span class="highlighted highlight-left">A remuneração</span></h2>
        <p>Nosso intuito é agregar ao mercado editorial brasileiro atual, sem nunca lutar contra ou prejudicar este importante pilar. <br/>Entretanto, entendemos que a democratização da publicação no Brasil esbarra em modelos financeiros intrínsecos ao setor. <br/>Por sermos digitais, os custos da operação são altamente reduzidos, nos possibilitando a melhor remuneração dos autores. </p>
        <div class="mt-5 d-flex flex-column flex-md-row justify-content-center">
          <div class="mb-5 mb-md-0 mr-md-5">
            <img src="/images/pages/about/remuneracao-mercado-editorial.png" alt="Mercado Editorial" />
          </div>
          <div>
            <img src="/images/pages/about/remuneracao-scriv.png" alt="Scriv" />
          </div>
        </div>

        <hr class="h-1 no-border background-color2 mt-5 mb-0" />

      </div>
    </section> <!-- END MONEY -->

    <!-- NUMBERS -->
    <section id="numbers">
      <div class="container pb-5">
        <h2 class="font-size-xLarge mb-4 text-center text-md-left"><span class="highlighted highlight-left">A Scriv</span> em números</h2>

        <div class="d-flex flex-column flex-md-row flex-wrap">
          <div class="text-center item mb-4 mb-md-0">
            <img src="/images/pages/about/numbers-authors.png" alt="" class="mb-3" />
            <p class="font-weight-bold text-color2 mb-0 font-size-large">+{{ numbers.authors }}</p>
            <p class="font-weight-bold text-uppercase mb-2">Autores</p>
            <p class="font-size-small">Nº de usuários <br/>com textos <br/>publicados</p>
          </div>
          <div class="text-center item mb-4 mb-md-0">
            <img src="/images/pages/about/numbers-users.png" alt="" class="mb-3" />
            <p class="font-weight-bold text-color2 mb-0 font-size-large">+{{ numbers.users }}</p>
            <p class="font-weight-bold text-uppercase mb-2">Leitores</p>
            <p class="font-size-small">Nº de leitores <br/>únicos que já <br/>visitaram a Scriv</p>
          </div>
          <div class="text-center item mb-4 mb-md-0">
            <img src="/images/pages/about/numbers-posts.png" alt="" class="mb-3" />
            <p class="font-weight-bold text-color2 mb-0 font-size-large">+{{ numbers.posts }}</p>
            <p class="font-weight-bold text-uppercase mb-2">Publicações</p>
            <p class="font-size-small">Textos únicos <br/>publicados pelos <br/>autores atuais</p>
          </div>
          <div class="text-center item mb-4 mb-md-0">
            <img src="/images/pages/about/numbers-books.png" alt="" class="mb-3" />
            <p class="font-weight-bold text-color2 mb-0 font-size-large">+{{ numbers.books }}</p>
            <p class="font-weight-bold text-uppercase mb-2">Livros</p>
            <p class="font-size-small">Livros publicados <br/>na plataforma <br/>em 2021</p>
          </div>
          <div class="text-center item">
            <img src="/images/pages/about/numbers-views.png" alt="" class="mb-3" />
            <p class="font-weight-bold text-color2 mb-0 font-size-large">+{{ numbers.views }}</p>
            <p class="font-weight-bold text-uppercase mb-2">Visualizações</p>
            <p class="font-size-small">Nº total de views <br/>dos textos e livros <br/>publicados na Scriv</p>
          </div>
        </div>

        <hr class="h-1 no-border background-color2 mt-5" />
      </div>
    </section> <!-- NUMBERS -->

    <!-- PROJECTS -->
    <section>
      <div class="container pb-5">
        <h2 class="font-size-xLarge mb-4 text-center text-md-left"><span class="highlighted highlight-left">Nossos</span> projetos</h2>

        <div class="d-flex flex-column flex-md-row flex-wrap justify-content-center text-center">
          <div class="px-4 col-12 col-md-4">
            <img src="/images/pages/about/project-podcast.png" alt="Podcast" class="mb-3" />
            <p class="font-size-small">Podcast da Scriv, com episódios <br/>quinzenais sobre o mercado editorial, <br/>o setor literário no Brasil e muito mais.</p>
            <a href="https://open.spotify.com/show/77kkJ5WrnvC83L74mSSea7" class="btn btn-primary" target="_blank">Quero Ouvir</a>
          </div>
          <div class="px-4 col-12 col-md-4">
            <img src="/images/pages/about/project-clube.png" alt="Clube do Livro" class="mb-3" />
            <p class="font-size-small">Clube online para leituras acompanhadas <br/>de obras da literatura nacional e internacional, <br/>com debates e discussões sobre os temas.</p>
            <a href="https://discord.com/channels/750008900350247032/788830036324515852" class="btn btn-primary" target="_blank">Quero Ler</a>
          </div>
          <div class="px-4 col-12 col-md-4">
            <img src="/images/pages/about/project-live.png" alt="Live" class="mb-3" />
            <p class="font-size-small">Em breve, lives exclusivas de autores da Scriv <br/>com seus leitores, criando um canal direto <br/>de comunicação e interação entre eles.</p>
            <a href="https://www.instagram.com/stories/highlights/18162392668093430/" class="btn btn-primary" target="_blank">Quero Ver</a>
          </div>
        </div>
      </div>
    </section> <!-- END PROJECTS -->

    <!-- INICIATIVAS -->
    <section>
      <div class="container pb-5">
        <h2 class="font-size-xLarge mb-5 text-center text-md-left"><span class="highlighted highlight-left">Iniciativas</span> Scriv</h2>

        <div class="d-flex flex-column flex-md-row align-items-md-center mb-5 text-center text-md-left">
          <div class="px-0 col-12 col-md-2 text-center mb-4 mb-md-0">
            <img src="/images/pages/about/scriv-eventos.png" alt="Scriv Eventos" />
          </div>
          <div class="pl-md-3">
            <p class="mb-0">Realização de eventos literários online com os autores da Scriv, promovendo a criação de conteúdo, expressão literária e disseminação de ideias, premiando os melhores autores e obras de todo o Brasil.</p>
          </div>
        </div>

        <div class="d-flex flex-column flex-md-row align-items-md-center mb-5 text-center text-md-left">
          <div class="px-0 col-12 col-md-2 mb-4 mb-md-0">
            <img src="/images/pages/about/scriv-classicos.png" alt="Scriv Clássicos" />
          </div>
          <div class="pl-md-3">
            <p class="mb-0">Obras de domínio público disponibilizadas integralmente na Scriv, provendo acesso aos principais livros da literatura nacional, assim como obras obrigatórias para vestibulares como Enem e Fuvest.</p>
          </div>
        </div>

        <div class="d-flex flex-column flex-md-row align-items-md-center mb-5 text-center text-md-left">
          <div class="px-0 col-12 col-md-2 mb-4 mb-md-0">
            <img src="/images/pages/about/scriv-studios.png" alt="Scriv Studios" />
          </div>
          <div class="pl-md-3">
            <p class="mb-0">Em breve, uma produtora audiovisual para adaptar as melhores histórias e obras publicadas na Scriv, em parceria com diretores e roteiristas nacionais e plataforma de streaming de nível mundial.</p>
          </div>
        </div>

      </div>
    </section> <!-- END INICIATIVAS -->
  </div>
</template>

<script>

export default {
  metaInfo: {
    title: 'Sobre nós'
  },
  data () {
    return {
      numbers: {
        authors: '30k',
        users: '400k',
        posts: '10k',
        books: '1k',
        views: '2M'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#cycle {
  .item {
    position: relative;

    @include tablet {
      width: 33%;
    }

    @include desktop {
      width: 20%;
    }

    &:last-child {
      &::after {
        display: none !important;
      }
    }

    &::after {
      content: '';
      display: none;

      @include desktop {
        display: block;
        background: url('/images/pages/about/arrow.png') left top no-repeat;
        width: 35px;
        height: 14px;
        position: absolute;
        right: -15px;
        top: 50px;
      }
    }
  }
}

#numbers {
  .item {
    position: relative;

    @include tablet {
      width: 33%;
    }

    @include tablet {
      width: 20%;
    }
  }
}
</style>
